/**
 * GET `get-mawb-airlines` → `[{ prefix, name }, ...]`.
 * Expects axios `response.data` shape: `{ result: [...] }` (optional `data` fallback).
 */
export type MawbAirlineRow = { prefix: string; name: string };

function extractRows(body: unknown): unknown[] {
  if (body == null) return [];
  if (Array.isArray(body)) return body;
  if (typeof body !== 'object') return [];
  const o = body as Record<string, unknown>;
  if (Array.isArray(o.result)) return o.result;
  if (Array.isArray(o.data)) return o.data;
  return [];
}

function toRow(item: unknown): MawbAirlineRow | null {
  if (!item || typeof item !== 'object') return null;
  const { prefix, name } = item as Record<string, unknown>;
  if (typeof prefix !== 'string' || typeof name !== 'string') return null;
  const p = prefix.trim();
  const n = name.trim();
  if (!n || !/^\d+$/.test(p)) return null;

  return {
    prefix: p.length < 3 ? p.padStart(3, '0') : p,
    name: n,
  };
}

export function parseMawbAirlinesResponse(body: unknown): MawbAirlineRow[] {
  const out: MawbAirlineRow[] = [];
  for (const item of extractRows(body)) {
    const row = toRow(item);
    if (row) out.push(row);
  }
  return out;
}
